// extracted by mini-css-extract-plugin
export default {"active":"faq_active__O30n-","item":"faq_item__Nq1Wa","title":"faq_title__10dkN","body":"faq_body__Pr2qB"};